import type { Address } from "viem"

import { DomainEvent } from "@/domains/events"

export class SuperVoterAccessGrantedEvent extends DomainEvent {
  static readonly TYPE = "vote-page.super-voter-access-granted"
  readonly type = SuperVoterAccessGrantedEvent.TYPE
  constructor(
    public readonly account: Address,
    public readonly transactionHash?: string,
  ) {
    super()
  }
}

export class SuperVoterAccessRevokedEvent extends DomainEvent {
  static readonly TYPE = "vote-page.super-voter-access-revoked"
  readonly type = SuperVoterAccessRevokedEvent.TYPE
  constructor(
    public readonly account: Address,
    public readonly transactionHash?: string,
  ) {
    super()
  }
}

export class SuperVoterManagerDelegatedEvent extends DomainEvent {
  static readonly TYPE = "vote-page.super-voter-manager-delegated"
  readonly type = SuperVoterManagerDelegatedEvent.TYPE
  constructor(
    public readonly account: Address,
    public readonly managerAddress: Address,
    public readonly transactionHash?: string,
  ) {
    super()
  }
}

